import React, { useRef } from "react";
import * as echarts from "echarts";
import "./chalk.js";
import "./style.scss";
import "./china.js";
import elementResizeEvent from "element-resize-event";
import { Spin } from "antd";
import _ from "lodash";

require("echarts/lib/component/tooltip");
export default class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.el = null;
    this.state = {};
  }

  componentDidMount() {
    if (this.el == null) {
      return;
    }
    this.chart = echarts.init(this.el, "chalk");
    if (this.props.option) {
      this.chart.setOption(this.props.option);
      this.props.pieEmphasis && this.pieEmphasis(this.props.option);
    }

    elementResizeEvent(this.el, () => {
      this.chart.resize({
        width: this.el.clientWidth,
        heigth: this.el.clietnHeigth,
      });
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.option, nextProps.option)) {
      // if (this.el == null) {
      //   return;
      // }
      // this.chart = echarts.init(this.el, "chalk");
      if (nextProps.option) {
        // this.chart.setOption(nextProps.option);
        nextProps.pieEmphasis && this.pieEmphasis(nextProps.option);
      }
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.el == null) {
      return
    }
    if (!_.isEqual(this.props.option, prevProps.option)) {
      if (!this.chart) { this.chart = echarts.init(this.el, 'chalk') }
      if (this.props.option) {
        this.chart.setOption(this.props.option, true)
        this.chart.resize({
          width: this.el.clientWidth,
          height: this.el.clientHeight
        })
      }
    }
    this.chart && this.chart.resize();
  }

  componentWillUnmount() {
    if (this.el == null) {
      return;
    }
    elementResizeEvent.unbind(this.el, () => { });
  }

  pieEmphasis = (option) => {
    if (!option.series) {
      return;
    }
    let index = 0; //高亮所在下标
    let dataLength = option.series[0].data.length; // 当前饼图有多少个扇形
    this.downplay(index, dataLength);
    this.highlight(index, dataLength);
    let mTime = setInterval(() => {
      this.downplay(index, dataLength);
      index++;
      this.highlight(index, dataLength);
    }, 3000);
    //  鼠标划入
    this.chart.on("mouseover", (e) => {
      // 停止定时器，清除之前的高亮
      clearInterval(mTime);
      this.chart.dispatchAction({
        type: "downplay",
        seriesIndex: 0 //清一下高亮
      });
      this.chart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: e.dataIndex, //当前鼠标选中的高亮
      });
    });
    this.chart.on("mouseout", (e) => {
      clearInterval(mTime);
      this.chart.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: e.dataIndex,
      }); //鼠标移出后先把上次的高亮取消
      // 高亮指定的数据图形
      this.highlight(index, dataLength);
      mTime = setInterval(() => {
        // 取消高亮指定的数据图形
        this.downplay(index, dataLength);
        index++;
        // 高亮指定的数据图形
        this.highlight(index, dataLength);
      }, 3000);
    });
  }

  downplay = (index, dataLength) => {
    this.chart.dispatchAction({
      type: "downplay",
      seriesIndex: 0,
      dataIndex: index % dataLength,
    });
  }
  highlight = (index, dataLength) => {
    this.chart.dispatchAction({
      type: "highlight",
      seriesIndex: 0,
      dataIndex: index % dataLength,
    });
  }

  render() {
    const { option, loading } = this.props;
    // console.log(option)
    // console.log(option) (option.series && option.series.length > 0 && option.series[0].data.length < 1)
    if (!option) {
      return (
        <div
          className="commonly-chart-wrapper"
          style={{ height: this.props.height, color: "#999" }}
        >
          暂无数据
        </div>
      );
    }
    return (
      <div
        className="commonly-chart-wrapper"
        style={{ height: this.props.height, width: this.props.width }}
      >
        {loading && (
          <div className="mask">
            <Spin></Spin>
          </div>
        )}
        {!loading && (
          <div
            className="commonly-chart"
            ref={(el) => {
              this.el = el;
            }}
            style={{ height: this.props.height }}
          ></div>
        )}
      </div>
    );
  }
}
